import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const closeMenu = useCallback(() => setMobileOpen(false), []);
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar mobileOpen={mobileOpen} onClose={closeMenu} />
      <div className="min-w-0 lg:pl-64">
        <Header mobileOpen={mobileOpen} onOpenMenu={() => setMobileOpen(true)} />
        <main className="min-w-0 p-3 sm:p-6">
          <Outlet />
        </main>
        <footer className="px-6 py-4 text-center text-xs text-slate-500">ABG powered by Facilities Solutions</footer>
      </div>
    </div>
  );
}
